function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M33.27 11.3l5.8 11.74 1.16 2.36 2.6.38 12.96 1.88-9.38 9.15-1.88 1.83.45 2.59 2.21 12.91-11.59-6.09-2.33-1.23-2.33 1.23-11.59 6.09 2.21-12.91.45-2.59-1.89-1.83-9.38-9.15 12.97-1.88 2.6-.38 1.16-2.36 5.8-11.74m-10.28 9.53L0 24.17l16.63 16.22-3.92 22.89 20.56-10.81 20.56 10.81-3.92-22.89 16.63-16.22-22.99-3.34L33.27 0 22.99 20.83z",
  id: "star-full_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.84 23.25l17.8 2.72-12.88 13.2L49.8 57.8 33.88 49l-15.91 8.8 3.04-18.63-12.88-13.2 17.8-2.72L33.88 6.3l7.96 16.95z",
  id: "star-full_svg__b"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star-full_svg__a"
});

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star-full_svg__a",
  fillOpacity: 0,
  stroke: "#000",
  strokeOpacity: 0
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star-full_svg__b"
}));

function SvgStarFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 63
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgStarFull;